export default "__VITE_ASSET__CgyQIh5B__"